import { useQuery, useQueryClient } from '@tanstack/react-query';
import axios from 'config/axios';
import { ReactQueryKeys } from 'config/constant';
import { useCheckoutFulfillment } from './useCheckoutFulfillment';

export const useGetAvailableCoupons = (params = {}) => {
  const {
    clientId,
    storeId,
    isUserLoggedIn,
    memberNumber,
    userToken,
  } = params;

  const fulfillment = useCheckoutFulfillment();

  const isReady = Boolean(isUserLoggedIn && memberNumber && userToken && storeId && !window.location.pathname.includes("checkout/catering-meal"))

  const body = {
    RSAClientId: clientId,
    ClientStoreId: +storeId || 1,
    AppName: isUserLoggedIn ? "shop" : "",
    member_number: isUserLoggedIn ? memberNumber : "",
    user_token: isUserLoggedIn ? userToken : "",
    Version: isUserLoggedIn ? "1" : "",
    DeviceType: isUserLoggedIn ? "web" : "",
    ...fulfillment,
  };

  const fetcher = async () => {
    if (!isUserLoggedIn) {
      return {};
    }
    
    const res = await axios.post('/AogGetCoupons', body);
    return res?.data?.data || {};
  };

  const queryResult = useQuery({
    queryKey: [ReactQueryKeys.AVAILABLE_COUPONS, clientId, storeId, isUserLoggedIn, memberNumber, userToken, fulfillment],
    queryFn: fetcher,
    enabled: isReady,
    refetchOnWindowFocus: (query) => !query.state.data,
  });

  return {...queryResult, data: queryResult.isLoading ? {} : queryResult.data};
};

export const useClearCouponsCache = () => {
  const queryClient = useQueryClient();
  return () => {
    queryClient.removeQueries({ queryKey: [ReactQueryKeys.AVAILABLE_COUPONS], exact: false })
  };
}